import React, { useState, useContext, useEffect } from 'react';
import { ValidatorForm } from 'react-material-ui-form-validator';
import { Checkbox, TextField, FormControlLabel, Button, Snackbar, AppBar, Toolbar, IconButton, Typography, Backdrop, CircularProgress, Fab, Grid } from '@material-ui/core';
import { MuiPickersUtilsProvider, KeyboardDateTimePicker } from '@material-ui/pickers';
import { makeStyles } from '@material-ui/core/styles';
import MuiAlert from '@material-ui/lab/Alert';
import KeyboardBackspaceIcon from '@material-ui/icons/KeyboardBackspace';
import CloseIcon from '@material-ui/icons/Close';
import SaveIcon from '@material-ui/icons/Save';
import moment from 'moment';
import DateFnsUtils from '@date-io/date-fns';
import 'date-fns';
import styles from "../../jss/material-dashboard-react/views/dashboardStyle.js";
import { ConvertToCurrentTimeZone, ConvertTimeToUTC } from '../header/timeFormatter';
import { TransactionTime } from '../common/transactionTime';
import { GlobalTheme } from '../../layouts/theme';
import { Theme } from '../contexts/themeContext.js';
import { Context } from "../contexts/siteContext.js";
import { HttpService } from "../../apiAuthorization/httpService";
import { OfflineService } from "../../offline/storageService/offlineService";
import { SaveJournalOfflineData } from "../../offline/dataService/journalOfflineData";
import InactiveTimeout from '../common/inactiveTimeout';
import Card from "../card/card.js";
import CardBody from "../card/cardBody.js";
import GridContainer from "../grid/gridContainer.js";
import GridItem from "../grid/gridItem.js";
import SmallMenu from '../header/smallMenu';
import StatusIcon from '../common/statusIcon';
import { Typeahead } from 'react-bootstrap-typeahead';

const useStyles = makeStyles(styles);

function Alert(props) {
    return <MuiAlert elevation={6} variant="filled" {...props} />;
}

export default function AddJournal(props) {
    const classes = useStyles();
    const { defaultSite } = useContext(Context);
    const { theme } = useContext(Theme);
    const offlineService = new OfflineService();
    const appJournalId = props.model.length === 0 ? 0 : props.model.AppJournalId;
    const journal = props.model.length === 0 ? {} : props.model;
    const action = props.model.length === 0 ? "Add" : "Edit";
    const [selectedDate, setSelectedDate] = useState(props.model.length === 0 ? ConvertToCurrentTimeZone(new Date(), "MM/DD/YYYY hh:mm a", null, defaultSite) : props.model.Time);
    const [completed, setCompleted] = useState(props.model.length === 0 ? false : props.model.Completed);
    const [whoCalled, setWhoCalled] = useState(props.model.length === 0 ? '' : props.model.WhoCalled);
    const [comments, setComments] = useState(props.model.length === 0 ? '' : props.model.Comments);
    const [whoCalleds, setWhoCalleds] = useState([]);
    const [modified, setModified] = useState(false);
    const [openError, setOpenError] = useState(false);
    const [errorMessage, setErrorMessage] = useState("");
    const [backDrop, setBackDrop] = useState(false);
    const currentTheme = theme ? (GlobalTheme[theme]) : (GlobalTheme[localStorage.getItem("theme")]);

    const closeErrorSnackbar = () => {
        setOpenError(false);
    };

    const cancel = () => {
        props.parentCallback();
    };

    const dateChanged = date => {
        date = moment(date).format("MM/DD/YYYY hh:mm a");
        setSelectedDate(date);
        setModified(true);
    };

    useEffect(() => {
        if (appJournalId === 0) {
            TransactionTime.begin('Journal');
        }
        getWhoCalledItems();
        // eslint-disable-next-line
    }, []);

    const getWhoCalledItems = () => {
        setBackDrop(true);
        HttpService.post('/Journal/GetWhoCalleds', { siteId: defaultSite.id })
            .then(async (result) => {
                if (result && result.offline) {
                    //get offline data
                    const offlineResult = await offlineService.getOfflinesBySite(defaultSite.id, "GetWhoCalleds");
                    setWhoCalleds(offlineResult.OfflineData);
                    setBackDrop(false);
                }
                else {
                    setWhoCalleds(result);
                    setBackDrop(false);
                }
            },
                (error) => {
                    console.log(error);
                    setBackDrop(false);
                });
    };

    const saveJournal = (goBack) => {
        if (backDrop) {
            return;
        }
        else if (modified) {
            let message = "";

            if (!whoCalled || whoCalled.trimStart() === "")
                message = "Please enter Who Called.";
            else if (selectedDate === "Invalid date")
                message = "Please select the valid Time.";

            if (message !== "") {
                setErrorMessage(message);
                setOpenError(true);
                return;
            }

            journal.SiteId = defaultSite.id;
            journal.WhoCalled = whoCalled;
            journal.Time = selectedDate;
            journal.Comments = comments;
            journal.Completed = completed;

            if (appJournalId === 0) {
                journal.AppJournalId = appJournalId;
                TransactionTime.end();
                TransactionTime.updateData(journal);
            }
            else {
                journal.AppJournalId = appJournalId;
                journal.ModifiedDateTime = ConvertTimeToUTC(new Date());
            }

            setBackDrop(true);
            HttpService.post('/Journal/SaveJournal', journal)
                .then(async result => {
                    if (result && result.offline) {
                        let indexedDBId = await SaveJournalOfflineData(defaultSite.id, appJournalId, "SaveJournal", journal, "/Journal/SaveJournal", false, false);
                        if (journal.AppJournalId === 0)
                            journal.AppJournalId = "$" + indexedDBId;
                        props.refreshGrid(journal);
                        props.parentCallback();
                    }
                    else {
                        await SaveJournalOfflineData(defaultSite.id, appJournalId, "SaveJournal", result.data, "/Journal/SaveJournal", true, false);
                        props.refreshGrid(result.data);
                        props.parentCallback();
                    }
                },
                    (error) => {
                        console.log(error);
                    }
                );
        }
        else if (goBack) {
            props.parentCallback();
        }
    };

    return (<>
        <GridContainer style={{ justifyContent: 'center' }}>
            <Snackbar open={openError} autoHideDuration={3000} onClose={closeErrorSnackbar} style={{ height: "100%" }}>
                <Alert onClose={closeErrorSnackbar} severity="error">
                    {errorMessage}
                </Alert>
            </Snackbar>
            <Backdrop className={classes.backdrop} id="journalBackdrop" open={backDrop}>
                <CircularProgress color="inherit" />
            </Backdrop>
            <AppBar style={{ background: currentTheme.primary, color: currentTheme.color }}>
                <Toolbar>
                    <IconButton edge="start" color="inherit" onClick={() => saveJournal(true)} aria-label="back">
                        <KeyboardBackspaceIcon />
                    </IconButton>
                    <Grid container direction="row" alignItems="center">
                        <Grid item>
                            <Typography variant="h6" className={classes.title}>{action} Journal</Typography>
                        </Grid>
                        <Grid item>
                            <StatusIcon />
                        </Grid>
                    </Grid>
                    <Grid container justify="flex-end">
                        <Fab style={{ background: currentTheme.secondary, color: "white" }} size="small" aria-label="close" onClick={props.parentCallback}>
                            <CloseIcon />
                        </Fab>
                        <SmallMenu moduleName={"Journal"} modified={modified} saveCallback={() => saveJournal(false)} />
                    </Grid>
                </Toolbar>
            </AppBar>
            <GridItem xs={12} sm={8} md={4}>
                <Card style={{ backgroundColor: currentTheme.background }}>
                    <CardBody style={{ color: currentTheme.text, marginTop: "50px", display: 'flex', justifyContent: 'center' }}>
                        <ValidatorForm className={classes.root} style={{ width: "100%", display: "block" }} autoComplete="off" onSubmit={() => saveJournal(false)}>
                            <Typeahead
                                style={{ width: 'auto', marginTop: '5px', color: 'inherit' }}
                                id="WhoCalled"
                                label="Who Called"
                                required
                                errorMessages={['This field is required']}
                                labelKey={(option) => `${option}`}
                                onChange={(arr) => {
                                    setWhoCalled(arr[0]);
                                    setModified(true);
                                }}
                                onBlur={(event) => {
                                    var value = event.target.value.trimStart();
                                    if (whoCalled !== value) {
                                        setModified(true);
                                    }
                                    setWhoCalled(value);
                                }}
                                defaultInputValue={whoCalled}
                                options={whoCalleds}
                                placeholder="Who Called"
                                renderMenuItemChildren={(option, key) => (
                                    <div className="dropdown-widget">
                                        <div className="left">{option}</div>
                                    </div>
                                )}
                            />
                            <br /><br />
                            <MuiPickersUtilsProvider utils={DateFnsUtils}>
                                <KeyboardDateTimePicker autoOk
                                    label="Time"
                                    variant="inline"
                                    inputVariant="outlined"
                                    format="MM/dd/yyyy hh:mm a"
                                    disableFuture="true"
                                    value={selectedDate}
                                    onChange={date => dateChanged(date)}
                                    InputAdornmentProps={{ position: "start" }}
                                    style={{ width: "100%" }}
                                />
                            </MuiPickersUtilsProvider>
                            <br /><br />
                            <TextField fullWidth
                                id="outlined-multiline-static"
                                label="Comments"
                                placeholder="Comments"
                                multiline
                                rows="4"
                                variant="outlined"
                                value={comments}
                                onChange={(e) => {
                                    setComments(e.target.value.trimStart());
                                    setModified(true);
                                }}
                                style={{ width: "100%" }}
                                InputLabelProps={{
                                    shrink: true
                                }}
                            />
                            <br /><br />
                            <FormControlLabel
                                value="end"
                                control={<Checkbox color="primary" />}
                                label="Completed"
                                labelPlacement="end"
                                checked={completed}
                                onChange={(e) => {
                                    setCompleted(e.target.checked);
                                    setModified(true);
                                }}
                            />
                            <br /><br />
                            <Button
                                variant="contained"
                                color="primary"
                                size="small"
                                style={{ background: currentTheme.secondary, width: "100px", float: "right" }}
                                startIcon={<SaveIcon />}
                                type="submit"
                            >
                                Save
                            </Button>
                        </ValidatorForm>
                    </CardBody>
                </Card>
            </GridItem>
            {(appJournalId === 0) && (
                <InactiveTimeout disContinue={cancel} />
            )}
        </GridContainer>
    </>
    )
}
